import React from 'react';

function Sidebar({ currentStep, setCurrentStep, isStepValid }) {
  const steps = ['Basic Information', 'Preferences', 'Places to Visit', 'Lodgings'];

  return (
    <div className="sidebar">
      <h3 className="sidebar-title">New Trip Questionnaire</h3>
      <ul className="sidebar-steps">
        {steps.map((step, index) => (
          <li
            key={index}
            onClick={() => isStepValid(index) && setCurrentStep(index)}
            className={`sidebar-step ${currentStep === index ? 'active-step' : ''} ${isStepValid(index) ? '' : 'disabled'}`}
          >
            {step}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Sidebar;
